import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ProductInventoryMovementAPI {

    URI_V1 = "/v1/product-movements";

    getCompanyId = () => companyAPI.getCompanyManagment().id;

    // 🔹 LISTAR
    findAll = async () => {
        return await apiService.get(
            `${this.URI_V1}?companyId=${this.getCompanyId()}`
        );
    };

    // 🔹 BUSCAR POR ID
    findById = async (productId: any) => {
        return await apiService.get(
            `${this.URI_V1}/${productId}?companyId=${this.getCompanyId()}`
        );
    };

    // 🔹 CRIAR
    create = async (data: any) => {
        return await apiService.post(
            `${this.URI_V1}?companyId=${this.getCompanyId()}`,
            data
        );
    };

    // 🔹 ATUALIZAR
    update = async (productId: any, data: any) => {
        return await apiService.put(
            `${this.URI_V1}/${productId}?companyId=${this.getCompanyId()}`,
            data
        );
    };

    // 🔹 DELETE (soft delete no backend)
    delete = async (movementId: any) => {
        return await apiService.delete(
            `${this.URI_V1}/${movementId}?companyId=${this.getCompanyId()}`
        );
    };

    findHistory = async (productId: any) => {
        return await apiService.get(
            `${this.URI_V1}/history?companyId=${this.getCompanyId()}&productId=${productId}`
        );
    };


}